import { render } from "./EredmenyMobil.vue?vue&type=template&id=351a5742&scoped=true"
import script from "./EredmenyMobil.vue?vue&type=script&lang=js"
export * from "./EredmenyMobil.vue?vue&type=script&lang=js"

import "./EredmenyMobil.vue?vue&type=style&index=0&id=351a5742&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-351a5742"]])

export default __exports__